export default {
  success: 'Pagamento Bem-Sucedido',
  failure: 'Falha no Pagamento',
  paymentSuccessful: 'Pagamento bem-sucedido',
  paymentFailed: 'Pagamento falhou',
  redirecting: '{seconds}s Então redirecionado para {target}',
  closeTips: '{seconds}s Então fechar',
}
